export const GOGO_DEBUG_LOG = localStorage.getItem('wuji:gogo:debugLog') === '1';
